import React from "react";
import "rapidoc";
import "./styles.css";

// Support runtime environment variables via window._env_ or fallback to build-time process.env
const REACT_APP_SWAGGER_URL = window._env_?.REACT_APP_SWAGGER_URL || process.env.REACT_APP_SWAGGER_URL || 'https://api-staging.materials.zone/v2beta1/swagger.json';

export default function App() {
  React.useEffect(() => {
    (async () => {
      let docEl = document.getElementById("thedoc");
      try {
        const specJson = await (await fetch(REACT_APP_SWAGGER_URL)).json();
        docEl.loadSpec(specJson);
      }
      catch (e) {
        docEl.loadSpec({}); // shows "Error loading the spec"
        console.log(e);
      }
    })();
  }, []);
  return (
    <rapi-doc
      id="thedoc"
      style={{ height: "100vh", width: "100%" }}
      render-style="read"
      show-header="false"
      show-info="true"
      info-description-headings-in-navbar="true"
      allow-spec-url-load="false"
      allow-spec-file-load="false"
      allow-spec-file-download="false"
      show-curl-before-try="false"
      allow-server-selection="false"
      theme="light"
      nav-bg-color="#f0f0f0"
      primary-color="#00bcd4"
      allow-authentication="true"
      allow-try="true"
      schema-style="tree"
      allow-search="false"
      allow-advanced-search="false"
      regular-font="sans-serif"
    >
      <img
        slot="nav-logo"
        class="nav-logo"
        src="logo.png"
      />
    </rapi-doc>
  );
}
